// The estimated selling price range is free-typed: the agent writes whatever
// they want in both ends and is flagged (never blocked) when the top end is
// outside 10% of the bottom end (Michael Piccoli, DOMA 13295853736 — replaces
// the auto 10% snap from DOMA 13214123746 / 13262358216).
import { parseMoney } from './marketingTotal';

// '' when the range is fine or incomplete; otherwise the warning to show.
// The 10% ceiling is rounded to the dollar so an exact 10% spread entered
// either way (e.g. 1,363,636 -> 1,500,000) is never flagged.
export function estimateRangeWarning(low, high) {
  const lo = parseMoney(low);
  const hi = parseMoney(high);
  if (!lo || !hi) return '';
  if (hi < lo) return 'The top of the range is below the bottom end.';
  if (hi > Math.round(lo * 1.1)) {
    return 'The top of the range is more than 10% above the bottom end.';
  }
  return '';
}
